// CSS
import "./stylesheets/application.scss";

// JS
import "./javascripts/app";
